/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Pressable, Text, Icon, Image } from '@components/atoms'
import { AppBar as MuiAppBar, styled, AppBarProps as MuiAppBarProps } from '@mui/material'
import Badge from '@mui/material/Badge'
import logoPng from '@public/images/logo/logo_black.png'
import logoWordingPng from '@public/images/logo/logo_wording.png'

import { useAppSelector, useAppDispatch, configActions } from '@redux/index'
import { useNavigate } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/types'
import { grey, pink } from '@mui/material/colors'

interface AppBarPropType extends MuiAppBarProps {
	open: boolean
}

interface PropsType {
	style?: React.CSSProperties
	menuList: HomeNavMenuType[]
}

export const HomeNav = (props: PropsType): JSX.Element => {
	const { menuList } = props
	// hook
	const navigate = useNavigate()

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isHomeOpenDrawer: boolean = useAppSelector(state => state.config.isHomeOpenDrawer)
	const isLogedin: boolean = useAppSelector(state => state.customerAuth.isLogedin)

	// state
	const [cartLength, setCartLength] = React.useState<number>(0)

	const backgroundColor = '#fff'

	React.useEffect(() => {
		handleStorage()

		window.addEventListener('storage', handleStorage)
		return () => window.removeEventListener('storage', handleStorage)
	}, [])

	const onMenuTogglePress = () => {
		reduxDispatch(configActions.IS_HOME_OPEN_DRAWER(!isHomeOpenDrawer))
	}

	const handleStorage = () => {
		const localeCartSrt = localStorage.getItem('cart')
		const localeCartList =
			localeCartSrt === null || localeCartSrt === '' ? [] : JSON.parse(localeCartSrt)
		const cartItemLength =
			!Array.isArray(localeCartList) || localeCartList.length === 0
				? 0
				: localeCartList.length

		setCartLength(cartItemLength)
	}

	const AppBar = styled(MuiAppBar, {
		shouldForwardProp: prop => prop !== 'open',
	})<AppBarPropType>(({ theme, open }) => ({}))

	return (
		<AppBar
			position="fixed"
			color="transparent"
			className="appBar"
			css={[
				style,
				{
					backgroundColor: backgroundColor,
				},
				{ ...props.style },
			]}
			elevation={0}
			open={false}
		>
			{/* <View className="topEventView">
				<Pressable className="topEventButton" onClick={() => navigate('/event')}>
					<Text category="h1">Black Friday Day Event</Text>
				</Pressable>
			</View> */}
			<View className="navOuter">
				<View className="navInner">
					<Pressable onClick={() => navigate('/')}>
						<View className="logoView">
							<Image
								src={logoPng}
								style={{
									height: '3rem',
									alignItems: 'flex-start',
								}}
							/>
							<Image
								src={logoWordingPng}
								style={{ width: '8rem', marginLeft: '1rem', alignItems: 'flex-start' }}
							/>
						</View>
					</Pressable>

					<View className="navMenuView">
						{menuList.map(aMenu => {
							return (
								<Pressable
									key={aMenu.id}
									className="navMenuButton"
									onClick={() => navigate(aMenu.uri)}
								>
									<Text>{aMenu.title}</Text>
								</Pressable>
							)
						})}

						{isLogedin ? (
							<Pressable
								className="navMenuButton"
								onClick={() => navigate('/customer/info')}
							>
								<Icon name="account-outline" css={{ fontSize: '26px' }} />
							</Pressable>
						) : (
							<Pressable
								className="navMenuButton"
								onClick={() => navigate('/customer/login')}
							>
								<Text>Login</Text>
							</Pressable>
						)}
						<Pressable className="navMenuButton" onClick={() => navigate('/cart')}>
							<Badge badgeContent={cartLength} color="error">
								<Icon name="cart-outline" css={{ fontSize: '26px' }} />
							</Badge>
						</Pressable>
					</View>

					<View className="menuNavButtonView">
						<Pressable className="menuNavButton" onClick={() => navigate('/cart')}>
							<Badge badgeContent={cartLength} color="error">
								<Icon name="cart-outline" css={{ fontSize: '26px' }} />
							</Badge>
						</Pressable>
						<Pressable className="menuNavButton" onClick={onMenuTogglePress}>
							<Icon name="menu" className="menuNavButtonIcon" />
						</Pressable>
					</View>
				</View>
			</View>
		</AppBar>
	)
}

const style = css({
	position: 'fixed',
	zIndex: 5,
	height: '5rem',
	borderBottom: `1px solid ${grey[300]}`,

	'.topEventView': {
		width: '100%',
		height: '5rem',
		background: pink['A400'],
		color: '#FFF',

		'.topEventButton': {
			width: '100%',
			height: '100%',
			color: '#FFF',

			'.h1': {
				margin: 0,
			},
		},
	},

	'.navOuter': {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',

		'.navInner': {
			display: 'flex',
			justifyContent: 'flex-start',

			'.logoView': {
				display: 'flex',
				height: '4.8rem',
				marginLeft: '1rem',
				alignItems: 'center',
			},

			'.navMenuView': {
				position: 'absolute',
				display: 'flex',
				height: '100%',
				right: '4rem',

				'.navMenuButton': {
					height: '4.8rem',
					width: 'fit-content',
					paddingRight: '2rem',
					paddingLeft: '2rem',
				},
			},
		},

		'.menuNavButtonView': {
			position: 'absolute',
			display: 'none',
			right: '1rem',
			height: '5rem',
			width: '8rem',

			'.menuNavButton': {
				height: '100%',
				width: '100%',

				'.menuNavButtonIcon': {
					fontSize: '36px',
				},
			},
		},
	},

	'@media (max-width: 890px)': {
		'.navOuter': {
			'.navInner': {
				'.navMenuView': {
					display: 'none',
				},
				'.menuNavButtonView': {
					display: 'flex',

					'.menuNavButton': {
						width: '4rem',
					},
				},
			},
		},
	},
})
